import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "@elastic/eui/dist/eui_theme_dark.css";
// import '@elastic/eui/dist/eui_theme_light.css';
// import '@elastic/eui/dist/eui_theme_amsterdam_light.css';
import "@elastic/eui/dist/eui_theme_amsterdam_dark.css";
import "./styles/styles.css";

ReactDOM.render(
  // cannot use React strict mode due to elastic UI
  <App />,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
